export const DefaultDelay = 1200;
export const ShortDelay = 800;
export const LongDelay = 1600;
